import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Layout from '../../Layouts/Layout'

const Idle = () => {
  return (
    <Layout showNav={false} showFooter={false}>
      <Container fluid className='border'>
        <Row>
          <Col xs={12}>
            <Container id='s2k' fluid className='shadow-sm my-2 pb-2'>
              <h3 className='h5'>Session Expired</h3>
              <div className='text-center'>
                Your session has expired, please restart application.
              </div>
            </Container>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Idle
